import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Linha, Interno } from '../../styles/base';

const CardNoticia = ({
  titulo, publicado, fotoCapa, html,
}) => (
  <div>
    <h2>{titulo}</h2>
    <p>
      Publicado em:
      {' '}
      {publicado}
    </p>
    {fotoCapa && (<div style={{ margin: '0 auto', display: 'flex' }}><img src={fotoCapa} style={{ width: '100%' }} alt="Foto de capa da notícia" /></div>)}
    <p>
      <Interno>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Interno>
    </p>
  </div>
);

CardNoticia.propTypes = {
  titulo: PropTypes.string,
  publicado: PropTypes.string,
  fotoCapa: PropTypes.string,
  html: PropTypes.string,
};

CardNoticia.defaultProps = {
  titulo: '',
  publicado: '',
  fotoCapa: '',
  html: '',
};

export default CardNoticia;
